// extracted by mini-css-extract-plugin
export var banner = "_i4-0";
export var closeButton = "_i4-2";
export var greenCheckmark = "_i4-3";
export var hereLink = "_i4-4";
export var titleIcon = "_i4-1";